import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fabricCategories } from '../../mocks/categories';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const FabricsPage = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (categoryId: string) => {
    navigate(`/fabrics/${categoryId}`);
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-b from-accent/5 to-transparent">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-5xl font-bold text-accent mb-6">
              مجموعة الأقمشة المميزة
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              اكتشف مجموعتنا الفاخرة من الأقمشة المستوردة من أفضل المصانع العالمية. نوفر لك أجود أنواع الأقمشة اليابانية والكورية والإندونيسية والهندية والصينية بجودة استثنائية
            </p>
          </div>
        </div>
      </section>

      {/* Categories Grid */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {fabricCategories.map((category) => (
              <div
                key={category.id}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
              >
                {/* Image */}
                <div className="relative h-80 overflow-hidden">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                  
                  {/* Category Badge */}
                  <div className="absolute top-6 right-6 bg-secondary text-white px-6 py-2 rounded-full font-bold">
                    {category.country}
                  </div>
                </div>

                {/* Content */}
                <div className="p-8">
                  <h3 className="text-3xl font-bold text-accent mb-4">
                    {category.name}
                  </h3>
                  <p className="text-gray-600 text-lg leading-relaxed mb-6">
                    {category.description}
                  </p>
                  
                  <button
                    onClick={() => handleCategoryClick(category.id)}
                    className="w-full bg-accent text-white py-4 rounded-full font-bold text-lg hover:bg-secondary transition-all group-hover:scale-105 whitespace-nowrap cursor-pointer flex items-center justify-center gap-3"
                  >
                    <span>تصفح الأقمشة</span>
                    <i className="ri-arrow-left-line"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-accent/5">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-secondary rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-4xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-accent mb-2">جودة مضمونة</h4>
              <p className="text-gray-600">جميع أقمشتنا مستوردة من أفضل المصانع العالمية</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-secondary rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-truck-line text-4xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-accent mb-2">توصيل سريع</h4>
              <p className="text-gray-600">نوفر خدمة توصيل سريعة لجميع أنحاء الكويت</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-secondary rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-4xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-accent mb-2">دعم متواصل</h4>
              <p className="text-gray-600">فريقنا جاهز لمساعدتك في اختيار القماش المناسب</p>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default FabricsPage;